<template>
  <van-overlay show class-name="history overflow-y-auto" z-index="1000">
    <van-list v-if="isLoad" :finished="finished" finished-text="没有更多了" v-model="loading">
      <div class="text-small text-theme-black-450 pt-4 pb-2">
        <span>历史答题记录</span>
      </div>
      <ul>
        <li v-for="item in historyList" :key="item.id" class="history-item">
          <div class="leading-22">
            <div class="text-theme-black-850">
              <span class="text-medium"> 第 {{ item.submitIdx }} 次提交 </span>
            </div>
            <div class="text-theme-black-450">
              <span class="text-small">{{ item.submitTime }}</span>
            </div>
          </div>
          <div class="text-theme">
            <span class="text-small" @click="onSelectAnswer(item)">查看</span>
          </div>
        </li>
      </ul>
    </van-list>
  </van-overlay>
</template>

<script>
import { filterParams, getAnswerHistory } from 'dygc'

export default {
  name: 'OverlayHistory',
  props: {
    accountUserId: {
      type: String,
      default: ''
    },
    accountUserFingerprint: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    accountUserOpenId:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      historyList: [],
      total: 0,
      loading: false,
      isLoad: false
    }
  },
  created() {
    this.getList()
  },
  computed: {
    finished() {
      return this.historyList.length === this.total
    }
  },
  methods: {
    onSelectAnswer(item) {
      this.$bus.answerId = item.id
      this.$bus.openLoading()
      this.$bus.scoreEnd = null
      this.$bus.isOpenReward = true
      this.$bus.getAnswerRes().then(res => {
        setTimeout(() => {
          this.onClose()
        }, 20)
      })
    },
    getList() {
      this.loading = true
      this.$bus.openLoading()
      const params = {
        accountUserId: this.accountUserId,
        surveyId: this.surveyId,
        accountUserFingerprint: this.accountUserFingerprint,
        accountUserOpenId: this.accountUserOpenId,
        size: 9999
      }
      getAnswerHistory(filterParams(params)).then(res => {
        let data = res.data
        console.log(data)
        this.historyList = data.records
        this.total = data.total
        this.loading = false
        this.$bus.closeLoading()
        this.isLoad = true
      })
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
